import {GameRoundPresentation} from "@nolimitcity/slot-game/bin/timelinegameround/core/gameround/GameRoundPresentation";
import {HarlequinParsedGameData} from "../../server/data/HarlequinParsedGameData";
import {Timeline, TimelineLite} from "gsap";
import {HarlequinGameModuleConfig} from "../../HarlequinGameModuleConfig";
import {SlotGame} from "@nolimitcity/slot-game/bin/core/SlotGame";

export class HarlequinWalkerManager implements GameRoundPresentation {

    //private readonly _reelId:number;
    private readonly _stepDuration: number;
    private readonly _abortDuration: number;

    private _hasWin:boolean = false;
    private _resetter:boolean = false;
    private _flusher:boolean = false;

    private _wildOverlayReels:boolean [] = [];
    private _wildOverlayReelsBefore:boolean [] = [];
    private _wildOverlays:boolean [] = [];

    private _wildMultipliers:number [] = [];
    private _wildMultipliersBefore:number [] = [];

    private _activateOnReelIndexes:number [] = [];
    private _isFreespin:boolean;

    private _gameData:HarlequinParsedGameData;
    private _tl: TimelineLite;
    private _wildDrop:boolean [] = [];
    private _isRestore:boolean;
    private _toMode:string;

    constructor(resetter:boolean = false, flusher:boolean = false, stepDuration:number = 0.2, abortDuration:number = 0.2) {
        this._resetter = resetter;
        this._flusher = flusher;
        this._stepDuration = stepDuration;
        this._abortDuration = abortDuration;

        //console.log("WALKER INSTANCE, id: " + this._reelId)
    }

    public getAnimation(data: HarlequinParsedGameData):Timeline {
        const tl = new TimelineLite();

        if(this._flusher) {
            tl.add(() => HarlequinGameModuleConfig.harlequinWalkerView.flush()); // TODO: Return tls
        }

        if(this._resetter) {
            tl.add(() => HarlequinGameModuleConfig.harlequinWalkerView.hardReset()); // TODO: Return tls
        }

        if (this._hasWin) {
            let wildDropped:boolean = false;

            tl.add(() => {
                this._activateOnReelIndexes.forEach((index) => {
                    // TODO: Walker View Activate
                    if(!(index === 4 && this._wildDrop && this._wildDrop[index])) {
                            HarlequinGameModuleConfig.harlequinWalkerView.addAndShowOverlay(index, undefined, this._wildMultipliers, undefined, undefined, (this._isRestore && index === 0));
                    }
                });
            });


            tl.add([
                    () =>  (this._isFreespin)? HarlequinGameModuleConfig.harlequinWalkerView.moveAllOverlaysFS(this._wildMultipliers) : HarlequinGameModuleConfig.harlequinWalkerView.moveAllOverlays(this._wildMultipliers)
                ],
                (!wildDropped)? "+=0" : "+=0.4");

            tl.add(() => {
                // Resore reset
                HarlequinGameModuleConfig.harlequinWalkerView.restoreReset();
            },this._activateOnReelIndexes.length * this._stepDuration);

            // TODO: update sign
            if(this._isFreespin) {
                const signTl:TimelineLite = new TimelineLite();
                signTl.add(() => {
                    let numberLeft: number = -1;
                    this._wildOverlays.forEach((evalVal: boolean, index: number) => {
                        if (evalVal) {
                            numberLeft = index;
                        }
                    });

                    //TODO: In FS do not send here
                    HarlequinGameModuleConfig.harlequinSignView.setRespinSignAnimation(--numberLeft);
                }, tl.totalDuration() + 0.4);
            }

        }

        this._tl = tl;
        return this._tl;
    }

    abort(isActive: boolean, data: HarlequinParsedGameData): Timeline | null {
        if(isActive && this._tl) {
            //GameRoundManager.detachAndPlayTimeline(this._tl);
            return this._tl;
        }
        else {
            if(this._hasWin) {
                return this.getAnimation(data);
            }
        }
        return null;
    }

    public prepare(data: HarlequinParsedGameData): void {

        if(this._flusher) {
            this._hasWin = false;
        }
        else if(this._resetter) {
            this._hasWin = false;
        }
        else {
            this._gameData = data;

            // Raw Members
            this._wildOverlayReels = data.wildOverlayReels || [];
            this._wildOverlayReelsBefore = data.wildOverlayReelsBefore || [];
            this._wildMultipliers = data.wildMultipliers || [];
            this._wildMultipliersBefore = data.wildMultipliersBefore || [];
            this._isFreespin = (data.mode === "WILD_RESPIN_FS" || data.nextMode === "WILD_RESPIN_FS");

            this._wildDrop = data.wildDrop || [false, false, false, false, false];

            // Calculated Members
            if((<any> data)!.isRestoreState) { // TODO: fugly re-cast, YO FIXIT!
                this._activateOnReelIndexes = this.determineActivationList(this._wildOverlayReels, this._wildOverlayReelsBefore, true);
            }
            else {
                this._activateOnReelIndexes = this.determineActivationList(this._wildOverlayReels, this._wildOverlayReelsBefore);
            }
            this._hasWin = !(this._wildOverlayReels.every(((value) => { return !value; })));
        }


        this._wildOverlays = data.wildOverlayReels || [];
        this._isRestore = (<any>data).isRestoreState;
        this._toMode = data.nextMode;
    }

/**
 * Determines which walkers to activate, return a number [] with the amount of steps fot the walker
 *  - Self contained steps -
 */
    protected determineActivationList(overlaysByReel:boolean [], previousOverlaysByReel:boolean [], restore:boolean = false):number [] {
        const resultArr:number [] = [];

        if(restore) {
            overlaysByReel.forEach((bool: boolean, index: number) => {
                if (bool) {
                    resultArr.push(index);
                }
            });
        }
        else {
            overlaysByReel.forEach((bool: boolean, index: number) => {
                if (index === 4 && bool) {
                    resultArr.push(4);
                }
                else
                if (bool && !previousOverlaysByReel[index + 1]) {
                    resultArr.push(index);
                }
            });
        }

        return resultArr;
    }

}